import EventsHandler from "../service/events";
import EVENTS from "../constants/events";
import {ScrollService} from "../service/scroll";
import {AnimationService} from "../service/animation";
import OpenDesktopNavigation from "../animations/open-desktop-navigation";
import CloseDesktopNavigation from "../animations/close-desktop-navigation";

export class NavigationComponent {
    private $root: JQuery;
    private $header: JQuery;
    private $body: JQuery;
    private window: any;
    private events: EventsHandler;
    private animations: AnimationService;

    constructor(element: HTMLElement) {
        this.$body = $('body');
        this.$header = $('[data-elementor-type="header"]');
        this.window = $(<any>window);
        this.$root = $(element);
    }

    protected init() {
        ScrollService.observeScroll().subscribe((top) => {
            if (0 === top) {
                this.$root.removeClass('l-navigation-bar--sticky');
            } else {
                this.$root.addClass('l-navigation-bar--sticky');
            }
        });
        this.$root
            .find('a')
            .on({mouseover: this.handleMouseOverLink})
            .on({mouseout: this.handleMouseOutLink})
        ;
        this.events.addListener(EVENTS.MENU_OPEN, this.handleMenuOpen);
        this.events.addListener(EVENTS.LANGUAGE_SWITCHER_OPEN, this.handleMenuClose);
        this.events.addListener(EVENTS.MENU_CLOSE, this.handleMenuClose);
    }

    protected handleMouseOverLink = (ev: MouseEvent) => {
        let $target = $(ev.currentTarget);
        this.$root.find('.js-navigation__sub-menu').removeClass('l-sub-navigation--active')
        $target.closest('.js-navigation__sub-menu').addClass('l-sub-navigation--active')
    }

    protected handleMouseOutLink = () => {
        this.$root.find('.js-navigation__sub-menu').removeClass('l-sub-navigation--active')
    }

    protected handleMenuOpen = () => {
        this.$body.addClass('is-nav-open');
        this.animations.run(OpenDesktopNavigation, this.$root);
        this.$body.on({mousedown: this.handleBodyClick});
    }

    protected handleMenuClose = () => {
        this.$body.removeClass('is-nav-open');
        this.animations.run(CloseDesktopNavigation, this.$root);
        this.$body.off({mousedown: this.handleBodyClick});
    }

    private handleBodyClick = (ev: MouseEvent) => {
        if ('true' === this.$root.attr('aria-expanded')) {
            if ($(ev.target).closest(this.$header).length === 0 && $(ev.target).closest(this.$root).length === 0) {
                this.events.emit(EVENTS.MENU_CLOSE);
            }
        }
    }

    public setEventHandler(events: EventsHandler) {
        this.events = events;
        return this;
    }

    public setAnimationHandler(animations: AnimationService) {
        this.animations = animations;
        return this;
    }
}